import web from "../src/images/s1.png";
import app from "../src/images/s2.png";
import androoid from "../src/images/s3.png";
import digital from "../src/images/s4.png";
import marketing from "../src/images/s5.png";
import software from "../src/images/s6.png";

const Sdata=[
    {
        imgsrc:web,
        title: 'Web Devlopment'
    },
    {
        imgsrc:app,
        title: 'App Devlopment'
    },
    {
        imgsrc:androoid,
        title: 'Android Devlopment'
    },
    {
        imgsrc:digital,
        title: 'Digital Marketing'
    },
    {
        imgsrc:marketing,
        title: 'Marketing'
    },
    {
        imgsrc:software,
        title: 'Software Devlopment'
    },
];

export default Sdata;